import { forwardRef, InputHTMLAttributes } from "react";
import "./Input.scss";

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "className"> & {
  /**
   * Additional CSS class names
   */
  className?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className = "", ...props }, ref) => {
  return <input ref={ref} className={`v2-input ${className}`} {...props} />;
});

Input.displayName = "Input";

export default Input;
